import { render, staticRenderFns } from "./EditJob.vue?vue&type=template&id=6c0b4250&"
import script from "./EditJob.vue?vue&type=script&lang=js&"
export * from "./EditJob.vue?vue&type=script&lang=js&"
import style0 from "./EditJob.vue?vue&type=style&index=0&id=6c0b4250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports